import { coreDataSecurityApplicationsIdMapSlice } from './update';
import { defaultApplicationsIdMapState } from './state';
import { joinSyncReducers } from '@sonar-software/xuder';

export const corePuleApplicationsIdMapReducers = joinSyncReducers(
	[ coreDataSecurityApplicationsIdMapSlice.syncReducer ],
	defaultApplicationsIdMapState
);
